


























































































































































import { Package, ParamsReloadType } from "@/enums/enums";
import { CheckMerchantPackage, MerchantId } from "@/helper/userHelper";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class MainNavbar extends Vue {
  created() {
    this.listMenu = this.SetListMenu();
  }

  private listMenu: Array<any> = [];
  private Emi = 10;
  private hideDropdown = false;

  public SetListMenu() {
    const lislMenu = [
      {
        name: "Menu_Home",
        icon: "",
        img: require("@/assets/img/menubar/ic_home.png"),
        link: { name: "home" },
      },
      {
        name: "Menu_Salary",
        icon: "",
        img: require("@/assets/img/menubar/ic_salary.png"),
        link: { name: "salary" },
        dropdown: [
          {
            name: "Salary_Pay_Run",
            link: { name: "salary" },
            option: [
              {
                name: "Create_Salary_Pay_Run",
                bg: "bgOption",
                link: { name: "salaryCreate" },
                canNotAccess: CheckMerchantPackage([Package.Free, Package.Basic, Package.Pro]),
              },
              { name: "Menu_Overview", link: { name: "salary" } },
            ],
          },
          {
            name: "Salary_Summary",
            link: { name: "salarySummary" },
            option: [
              {
                name: "Create_Salary_Summary",
                bg: "bgOption",
                link: { name: "salary", at: "ca" },
                canNotAccess: CheckMerchantPackage([Package.Free, Package.Basic, Package.Pro]),
              },
              { name: "Menu_Overview", link: { name: "salarySummary" } },
            ],
          },
        ],
      },
      {
        name: "Menu_Employee",
        icon: "",
        img: require("@/assets/img/menubar/ic_employee.png"),
        link: { name: "employee" },
      },
      {
        name: "Menu_Department",
        icon: "",
        img: require("@/assets/img/menubar/ic_position.png"),
        link: { name: "department" },
      },
      {
        name: "Menu_Revenue_Deduct",
        icon: "",
        img: require("@/assets/img/menubar/ic_revenue.png"),
        link: { name: "revenue" },
      },
      {
        name: "Menu_Setting",
        icon: "",
        img: require("@/assets/img/menubar/ic_setting.png"),
        link: { name: "setting" },
      },
    ];
    return lislMenu;
  }

  public checkActiveMenu(linkName: any) {
    if (linkName && this.$route.matched.length > 0) {
      if (linkName.name == this.$route.matched[0].name) {
        return true;
      } else {
        return false;
      }
    }
  }

  public SetQueryURL(option: any) {
    const query: any = {
      emi: MerchantId().PeakEncryption(),
      reload: ParamsReloadType.Reload,
    };

    if (option.link && option.link.at) {
      query.at = option.link.at;
    }

    return query;
  }

  public Hide() {
    this.hideDropdown = true;
    setTimeout(() => {
      this.hideDropdown = false;
    }, 500);
  }
}
